export default __webpack_public_path__ + "static/media/iuoc2000.bd05d62b.png";